import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { createQueryClient } from './api/queries';
import { applyPrefs } from './app/prefs';
import { createRouter } from './app/router';
// 样式只引用 console/design 样式包（不复制，技术栈契约「样式与组件」），再接诊断自己的布局
import '../../../design/tokens.css';
import '../../../design/console.css';
import './styles/diagnostics.css';

async function start() {
  // 只有 `vite --mode mock` 才加载 mock；生产构建里这条分支是死代码，被摇掉（scripts/check-dist.mjs 复查）
  if (import.meta.env.MODE === 'mock') {
    const { startMockWorker } = await import('./mocks/browser');
    await startMockWorker();
  }
  const root = document.getElementById('root');
  if (!root) throw new Error('index.html 里缺少 #root');
  applyPrefs();
  createRoot(root).render(
    <StrictMode>
      <QueryClientProvider client={createQueryClient()}>
        <RouterProvider router={createRouter()} />
      </QueryClientProvider>
    </StrictMode>,
  );
}

void start();
